import script from "./verticalSpacer.vue?vue&type=script&lang=js"
export * from "./verticalSpacer.vue?vue&type=script&lang=js"

import "./verticalSpacer.vue?vue&type=style&index=0&id=19259c94&lang=scss"

const __exports__ = script;

export default __exports__